import React, { PureComponent } from 'react';
import BackToTop from './backToTop';

export default class OnIntersectionBackToTop extends PureComponent {
  constructor() {
    super();

    this.state = { visible: false };

    this.intersectionObserver = new IntersectionObserver(([entry]) => {
      this.setState({
        visible: !entry.isIntersecting && entry.boundingClientRect.top < 0,
      });
    });
  }

  componentDidMount() {
    const { selector } = this.props;
    this.intersectionObserver.observe(document.querySelector(selector));
  }

  componentWillUnmount() {
    this.intersectionObserver.disconnect();
  }

  render() {
    const { visible } = this.state;
    return <BackToTop {...this.props} visible={visible} />;
  }
}
